import FeatureGates from '@atlaskit/feature-gate-js-client';

import { ATLENZ_FF } from 'src/constants';

export const getContentProduct = (product: string[] | null): string => {
  const DEFAULT_PRODUCT = 'atlassian';
  const supportedProductsList = [
    'atlas',
    'atlassian',
    'bamboo',
    'bitbucket',
    'clover',
    'compass',
    'confluence',
    'crowd',
    'crucible',
    'fisheye',
    'focus',
    'guard',
    'jira',
    'jiraAlign',
    'jiraProductDiscovery',
    'jiraServiceManagement',
    'loom',
    'opsgenie',
    'rovo',
    'sourcetree',
  ];
  const isAtlenzAvailable = FeatureGates.checkGate(ATLENZ_FF);

  const toCamelCase = (str: string): string =>
    str
      .toLowerCase()
      .split(isAtlenzAvailable ? '-' : ' ')
      .map((word, index) => (index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)))
      .join('');

  if (product && product.length === 1) {
    let currentProduct = toCamelCase(product[0]);

    if (currentProduct === 'jiraCore') {
      currentProduct = 'jira';
    }

    if (currentProduct === 'atlassianGuard') {
      currentProduct = 'guard';
    }

    const productSupported = supportedProductsList.includes(currentProduct);

    return productSupported ? currentProduct : DEFAULT_PRODUCT;
  }

  return DEFAULT_PRODUCT;
};
